/// <reference path='references.ts' />

class TimeUnitUtil {

    public static updateDurationFields(idTimeUnitSelector: string, hoursMinsSelector: string, daysSelector: string ) {
        let selectedTimeUnitId = $(idTimeUnitSelector).val();
        let workingDaysUnitId = "2";
        if (!selectedTimeUnitId) {
            return;
        }

        if (selectedTimeUnitId === workingDaysUnitId) {
            if ($(hoursMinsSelector).is(":visible")) {
                $(hoursMinsSelector).hide();
                $(hoursMinsSelector + ' :input').prop('disabled', true);
                $(daysSelector).show();
                $(daysSelector + ' :input').spinner('enable');
                $(daysSelector + ' :input').val('');
            }
        } else if (!$(hoursMinsSelector).is(":visible")) {
            $(hoursMinsSelector).show();
            $(hoursMinsSelector + ' :input').prop('disabled', false);
            $(hoursMinsSelector + ' :input').val('');
            $(daysSelector).hide();
            $(daysSelector + ' :input').spinner('disable');
        }
    }
}
